import {
  Bot,
  Calendar,
  FileSpreadsheet,
  Github,
  Mail,
  MessageSquare,
  MessagesSquare,
  Video,
} from 'lucide-react';

export const INTEGRATION_META = {
  'google-calendar': {
    icon: Calendar,
    accent: 'text-blue-500',
    badgeClass: 'bg-blue-500/10 text-blue-300 border-blue-500/20',
    shortDescription: 'Calendar sync, availability, and booking support.',
    setupTitle: 'Connect Google Calendar',
    setupDescription: 'Connect a calendar account so Apollo can check availability and coordinate bookings.',
  },
  gmail: {
    icon: Mail,
    accent: 'text-red-400',
    badgeClass: 'bg-red-500/10 text-red-300 border-red-500/20',
    shortDescription: 'Read and send email through a connected Gmail account.',
    setupTitle: 'Connect Gmail',
    setupDescription: 'Connect a Gmail inbox for email reading, drafting, and sending workflows.',
  },
  'google-drive': {
    icon: FileSpreadsheet,
    accent: 'text-emerald-400',
    badgeClass: 'bg-emerald-500/10 text-emerald-300 border-emerald-500/20',
    shortDescription: 'Work with Drive files, Docs, and Sheets.',
    setupTitle: 'Connect Google Drive',
    setupDescription: 'Connect Drive so Apollo can create and update files, Docs, and Sheets.',
  },
  'google-meet-import': {
    icon: Video,
    accent: 'text-teal-400',
    badgeClass: 'bg-teal-500/10 text-teal-300 border-teal-500/20',
    shortDescription: 'Enable Google Meet transcript and artifact import using connected Google integrations.',
    setupTitle: 'Enable Google Meet Import',
    setupDescription: 'Turn on Google Meet artifact import using your connected Google Calendar and Google Drive integrations.',
  },
  github: {
    icon: Github,
    accent: 'text-slate-200',
    badgeClass: 'bg-slate-500/10 text-slate-200 border-slate-500/20',
    shortDescription: 'Repos, issues, pull requests, and project automation.',
    setupTitle: 'Connect GitHub',
    setupDescription: 'Add a GitHub token so Apollo can inspect repositories and help with issue workflows.',
  },
  slack: {
    icon: MessagesSquare,
    accent: 'text-fuchsia-400',
    badgeClass: 'bg-fuchsia-500/10 text-fuchsia-300 border-fuchsia-500/20',
    shortDescription: 'Post messages and work with channels in Slack.',
    setupTitle: 'Connect Slack',
    setupDescription: 'Connect Slack so Apollo can post updates and operate in approved channels.',
  },
  telegram: {
    icon: MessageSquare,
    accent: 'text-cyan-400',
    badgeClass: 'bg-cyan-500/10 text-cyan-300 border-cyan-500/20',
    shortDescription: 'Bot messaging and chat-based control in Telegram.',
    setupTitle: 'Connect Telegram',
    setupDescription: 'Add a Telegram bot token and approved chat settings for safe bot control.',
  },
  'outlook-mail': {
    icon: Mail,
    accent: 'text-indigo-400',
    badgeClass: 'bg-indigo-500/10 text-indigo-300 border-indigo-500/20',
    shortDescription: 'Read, search, draft, and send mail through a connected Outlook account.',
    setupTitle: 'Connect Outlook Mail',
    setupDescription: 'Connect Outlook Mail with mail-only Microsoft scopes so Apollo can work with inbox workflows without requesting calendar or file access.',
  },
};

export const getIntegrationMeta = (integrationId) => INTEGRATION_META[integrationId] || {
  icon: Bot,
  accent: 'text-primary',
  badgeClass: 'bg-primary/10 text-primary border-primary/20',
  shortDescription: 'Connect this integration to extend Apollo.',
  setupTitle: 'Connect integration',
  setupDescription: 'Configure this integration for your workspace.',
};
